import type { LOCATION_SEARCH_TYPE } from '@/types'

import { buildTypeaheadItemName, DEFAULT_TYPEAHEAD_CHIP } from '../ga4'
import { getTypeaheadBadge } from './getTypeaheadBadge'

export type ResolveTypeaheadItemNameParams = {
  item: Pick<LOCATION_SEARCH_TYPE, 'type' | 'popular' | 'trending'>
  isHotelTypeahead: boolean
  popularTrendingVariant: string | undefined
  searchType: string | undefined
}

/**
 * Resolves the structured hotel `item_name` (`[chip]_[entity]_[search-type]`) for a
 * typeahead selection, or `undefined` for non-hotel typeaheads.
 *
 * Shared by both typeahead implementations — Horizon's `AutocompleteWrapper` and the
 * legacy `TypeAhead` — so a given selection produces an identical value regardless of
 * which code path rendered it.
 */
export function resolveTypeaheadItemName({
  item,
  isHotelTypeahead,
  popularTrendingVariant,
  searchType,
}: ResolveTypeaheadItemNameParams): string | undefined {
  if (!isHotelTypeahead) return undefined

  const badge = getTypeaheadBadge({ item, variant: popularTrendingVariant })

  return buildTypeaheadItemName({
    chip: badge ?? DEFAULT_TYPEAHEAD_CHIP,
    type: item.type,
    searchType,
  })
}
